import { render } from "./BagicPaging.vue?vue&type=template&id=350e35b6"
import script from "./BagicPaging.vue?vue&type=script&lang=js"
export * from "./BagicPaging.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__